import { compose, withProps } from 'recompose'
import { withTranslation } from 'react-i18next'
import onClickOutside from 'react-onclickoutside'
import { connect } from 'react-redux'
import { placeThread } from '../../../../store/actions/discuss'
import { setMode } from '../../../../store/actions/app'

export const BlockViewOptionsContainer = compose(
  connect(
    () => ({}),
    {
      placeThread,
      setMode
    }
  ),
  withProps(({ block, position, closeContextMenu, placeThread, setMode }) => ({
    src: block.image.src,
    originalSource: block.image.originalLink || block.image.sourceUrl,
    handleClickOutside: () => closeContextMenu(),
    discuss: () => {
      closeContextMenu()
      setMode('discuss')
      const blockHeight = block.aspect
        ? block.width * block.aspect
        : block.height
      return placeThread({
        top: colWidth => position.top / (blockHeight * colWidth),
        left: colWidth => position.left / (block.width * colWidth),
        blockId: block.id
      })
    }
  })),
  onClickOutside,
  withTranslation()
)

export default BlockViewOptionsContainer
